import { Component, OnInit } from '@angular/core';
import {CreateUser} from '../Account/CreateUser';
import {AppService} from '../app.service';

declare let $: any;

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css', '../app.component.css']
})
export class LoginPageComponent implements OnInit {
  hasAccount = true;
  forgotPassPanel = false;

  logEmail = "";
  logPass = "";
  agreeToTerms: boolean = false;
  rememberLogin = false;

  cEmail = "";
  cEmailConf = "";
  cPass = "";
  cPassConf = "";
  passResetEmail = "";
  loginAccountError = "";
  createAccountError = "";

  boxHeight = '100%';
  ytBoxHeight = "300px";

  readTermsOfUse = false;

  constructor(public app: AppService) { }

  ngOnInit() {
    this.resetBoxHeight();
    window.onresize = () => {
      this.resetBoxHeight();
    };
  }

  openInNewTab(url) {
    let win = window.open(url, '_blank');
    win.focus();
  }

  jumpToContactUs() {
    window.location.href = "/contact-us";
    return;
  }

  resetBoxHeight() {
    let sb = $('#sponsorBox');
    if (!sb || !sb[0]) {
      this.boxHeight = '100%';
    } else {
      let h = sb[0].clientHeight;
      this.boxHeight = h + 'px';
    }

    let yt = $('#ytBox');
    if (!yt || !yt[0]) {
      this.ytBoxHeight = '300px';
    } else {
      let w = Math.floor(yt[0].clientWidth / 1.77);
      this.ytBoxHeight = w + 'px';
    }
  }


  logIntoAccount() {
    this.loginAccountError = "";
    if (this.logEmail.length === 0 || this.logPass.length === 0) {
      this.loginAccountError = "Please finish your credentials to login.";
      return;
    } else if (!this.agreeToTerms) {
      this.loginAccountError = "Please read and agree to the Terms and Conditions to login.";
      return;
    }
    this.app.logIntoAccount(this.logEmail, this.logPass).subscribe((user) => {
      console.log("User logged in: ", user);
      console.log("Session: ", this.app.getSessionID());
      this.logEmail = "";
      this.logPass = "";
      this.app.user = user;
      this.app.loggedIn = true;
      this.app.setSession(this.app.user.current_session);
      if (this.rememberLogin) {
        this.app.setUserID(this.app.user.id);
      }
      if (this.app.defer !== null) {
        this.app.defer();
        this.app.defer = null;
        setTimeout(() => {
          this.app.getAllCardsForUser();
        }, 500);
      } else {
        this.app.getAllCardsForUser();
      }

      $('#loginModal').modal('hide');
      if (!this.app.user.verified) {
        $('#verifyAccountModal').modal('show');
      }
    }, (error) => {
      console.log("Error logging in: ", error);
      this.loginAccountError = "The email or password you entered was incorrect, please try again.";
    });
  }

  passKeyUp(e) {
    console.log("Testing: ", e.keyCode);
    if (e.keyCode === 13) {
      this.logIntoAccount();
    }
  }

  resetPassword() {
    this.app.forgotPassword(this.passResetEmail).subscribe((data) => {
      console.log("Pass reset data: ", data);
      alert("Your password has been reset. Please check your email.");
      this.passResetEmail = "";
      this.forgotPassPanel = false;
    }, (error) => {
      console.log("Pass reset error: ", error);
      if (error.status === 412) {
        console.log("User not found");
        alert("No user was found for the email address you entered, please try again.");
      } else if (error.status === 403) {
        console.log("Please verify the account to reset the password.");
        alert("The email you entered is for an unverified account. Please check your email.");
      } else {
        console.log("Unknown error");
        alert("An unknown error occurred. Please try again later.");
      }
    });
  }


  getModalWidth() {
    let width = Math.floor(window.innerWidth * .9);
    return {width: width + 'px'};
  }

  getDialogWidth() {
    let width = Math.floor(window.innerWidth * .9);
    let left = Math.floor((window.innerWidth - width) / 2);
    return {width: width + 'px', left: left + "px"};
  }

  needToCreateAccount(val) {
    this.hasAccount = val;
  }

  showTermsOfUse() {
    console.log("Show terms of use");
    window.open("https://2018systems.com/assets/termsOfUse.pdf", '_blank');
  }

  forgotPassword() {
    this.forgotPassPanel = true;
  }

  rememberedPassword() {
    this.forgotPassPanel = false;
  }

  validateEmail(email) {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  validatePassword(pass) {
    let re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
    return re.test(String(pass));
  }


  createPassKeyUp(e) {
    if (e.keyCode === 13) {
      this.logIntoAccount();
    }
  }

  createAccount() {
    console.log("Email: ", this.cEmail);
    if (!this.readTermsOfUse) {
      this.createAccountError = "Please read our Terms of Use.";
      return;
    }
    if (!this.validateEmail(this.cEmail)) {
      this.createAccountError = "Please enter a valid email address.";
      console.log("Invalid email address");
      return;
    }
    if (this.cEmail !== this.cEmailConf) {
      this.createAccountError = "The emails that you entered do not match.";
      return;
    }
    if (!this.validatePassword(this.cPass)) {
      this.createAccountError = "The password you entered is not valid. The password must contain one lower case letter, one uppercase, one number, and be at least 8 characters.";
      return;
    }
    if (this.cPass !== this.cPassConf) {
      this.createAccountError = "The passwords you entered do not match.";
      return;
    }
    this.createAccountError = "";
    let cu = new CreateUser("", this.cPass, this.cEmail, 0, 0, "");
    this.app.createAccount(cu).subscribe((result) => {
      console.log("Account created: ", result);
      this.app.loggedIn = true;
      this.app.user = result;
      this.app.setUserID(this.app.user.id);
      if (this.app.defer !== null) {
        this.app.defer();
        this.app.defer = null;
      }
      $('#loginModal').modal('hide');
      if (!this.app.user.verified) {
        $('#verifyAccountModal').modal('show');
      }
    }, (error) => {
      if (error.status === 409) {
        console.log("Email already exists.");
        this.createAccountError = "The email you entered already exists. Please use a different email or use the forgot password link.";
        return;
      }
      console.log("Error making account: ", error);
    });
  }

}
